__turbopack_context__.v({
  "hero": "CollectionHero-module-scss-module__EtJwia__hero",
  "hero__action": "CollectionHero-module-scss-module__EtJwia__hero__action",
  "hero__copy": "CollectionHero-module-scss-module__EtJwia__hero__copy",
  "hero__description": "CollectionHero-module-scss-module__EtJwia__hero__description",
  "hero__headline": "CollectionHero-module-scss-module__EtJwia__hero__headline",
  "hero__image": "CollectionHero-module-scss-module__EtJwia__hero__image",
  "hero__media": "CollectionHero-module-scss-module__EtJwia__hero__media",
});
